import { Box, CircularProgress } from '@mui/material'

export const LoadingSkeleton = () => {
  return (
    <Box
      sx={{
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <CircularProgress />
    </Box>
  )
}
